import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ENV_CONFIG } from '@ps/core-config';
import { IrGeneratorResponseDto } from './dtos/ir-generator.dto';
import { IrGeneratorMapper } from './mappers/ir-generator.mapper';
import { IrGeneratorPayloadMapper } from './mappers/ir-generator.payload.mapper';

@Injectable({ providedIn: 'root' })
export class IrGeneratorApi {
  private readonly _http = inject(HttpClient);
  private readonly _envConfig = inject(ENV_CONFIG);
  private readonly _mapper = new IrGeneratorMapper();
  private readonly _payloadMapper = new IrGeneratorPayloadMapper();

  private readonly _baseUrl = `${this._envConfig.pureSpectrum.url}/ir-generator/chat/gpt`;

  public generateResponse(prompt: string): Observable<string> {
    return this._http
      .post<IrGeneratorResponseDto>(
        this._baseUrl,
        this._payloadMapper.toPayload(prompt),
      )
      .pipe(map((response) => this._mapper.fromDto(response)));
  }
}
